import httpClient from "./httpClient";
import { Suburb } from "../types/locations";
import { SuburbRadiusSearch, SuburbSearchQuery } from "../types/searches";

const END_POINT = "/suburbs";

const suburbSearch = async ({
	query,
	limit = 20
}: SuburbSearchQuery): Promise<Suburb[] | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${query}/${limit}`);
	return response.data as Suburb[];
};

const radiusSearch = async ({
	suburb,
	postcode,
	radius
}: SuburbRadiusSearch): Promise<Suburb[] | undefined> => {
	const response = await httpClient.get(
		`${END_POINT}/radius/${suburb}/${postcode}/${radius}`
	);
	return response.data as Suburb[];
};

export { suburbSearch, radiusSearch };
